import { Link } from 'react-router-dom';

import { ROUTES } from '../../../core/constants/navigation';
import { PAGE_META } from '../../../core/constants/seo';
import { useHashScroll } from '../../../core/hooks/useHashScroll';
import { usePageMeta } from '../../../core/hooks/usePageMeta';
import { site } from '../../../global/config/site';

import '../styles/privacy.css';

const PAGE = { ...PAGE_META.PRIVACY, url: `${site.url}${PAGE_META.PRIVACY.path}` };
const LAST_UPDATED = '14 de octubre de 2026';

export default function Privacy() {
    useHashScroll();
    usePageMeta(PAGE);

    return (
        <div className="layout-container">
            <article className="privacy">
                <nav className="privacy__breadcrumb" aria-label="Ruta de navegación">
                    <Link to={ROUTES.HOME}>Inicio</Link>
                    <span aria-hidden="true">/</span>
                    <span aria-current="page">Política de tratamiento de datos</span>
                </nav>
    
                <header className="privacy__header">
                    <h1 className="privacy__title">Política de tratamiento de datos personales</h1>
                    <p className="privacy__meta">Última actualización: {LAST_UPDATED}</p>
                </header>
    
                <div className="privacy__body">
                    <section>
                        <h2>1. Responsable del tratamiento</h2>
                        <p>
                            Total Medios (en adelante, “Total Medios”) es responsable del tratamiento de los datos personales que
                            recolecta a través del sitio web {site.domain} y de sus canales de contacto. Para cualquier asunto
                            relacionado con esta política puedes escribir a{' '}
                            <a href={`mailto:${site.contactEmail}`}>{site.contactEmail}</a>.
                        </p>
                    </section>
    
                    <section>
                        <h2>2. Marco legal</h2>
                        <p>
                            Esta política se rige por la Ley Estatutaria 1581 de 2012, el Decreto 1377 de 2013 (compilado en el
                            Decreto 1074 de 2015) y las demás normas colombianas que regulan la protección de datos personales.
                        </p>
                    </section>
    
                    <section>
                        <h2>3. Datos que recolectamos</h2>
                        <p>
                            A través del formulario de contacto recolectamos nombre, correo electrónico, teléfono, nombre del medio
                            o empresa, servicio de interés y la información que decidas compartir sobre tu proyecto. No recolectamos
                            datos sensibles ni datos de niñas, niños o adolescentes.
                        </p>
                    </section>
    
                    <section>
                        <h2>4. Finalidades</h2>
                        <ul>
                            <li>Responder tus solicitudes de información, asesoría o cotización.</li>
                            <li>Agendar reuniones y hacer seguimiento comercial a tu solicitud.</li>
                            <li>Elaborar y enviar propuestas de servicios.</li>
                            <li>Enviar información sobre nuestros servicios, cuando lo hayas autorizado.</li>
                            <li>Cumplir obligaciones legales y contractuales.</li>
                        </ul>
                    </section>
    
                    <section>
                        <h2>5. Derechos del titular</h2>
                        <p>Como titular de los datos tienes derecho a:</p>
                        <ul>
                            <li>Conocer, actualizar y rectificar tus datos personales.</li>
                            <li>Solicitar prueba de la autorización otorgada.</li>
                            <li>Ser informado sobre el uso que se ha dado a tus datos.</li>
                            <li>Presentar quejas ante la Superintendencia de Industria y Comercio.</li>
                            <li>Revocar la autorización y solicitar la supresión de tus datos cuando no exista un deber legal o contractual de conservarlos.</li>
                            <li>Acceder de forma gratuita a tus datos personales.</li>
                        </ul>
                    </section>
    
                    <section>
                        <h2>6. Consultas y reclamos</h2>
                        <p>
                            Puedes ejercer tus derechos escribiendo a <a href={`mailto:${site.contactEmail}`}>{site.contactEmail}</a>{' '}
                            con tu nombre, datos de contacto y la descripción de tu solicitud. Las consultas se atienden en un
                            máximo de diez (10) días hábiles y los reclamos en un máximo de quince (15) días hábiles, según los
                            términos de la Ley 1581 de 2012.
                        </p>
                    </section>
    
                    <section>
                        <h2>7. Seguridad y conservación</h2>
                        <p>
                            Aplicamos medidas técnicas, humanas y administrativas razonables para proteger tus datos contra pérdida,
                            consulta, uso o acceso no autorizado. Conservamos la información solo durante el tiempo necesario para
                            cumplir las finalidades descritas.
                        </p>
                    </section>
    
                    <section>
                        <h2>8. Vigencia</h2>
                        <p>
                            Esta política rige a partir de su publicación. Cualquier cambio sustancial será informado a través de
                            este sitio web.
                        </p>
                    </section>
                </div>
            </article>
        </div>
    );
}
